/* ============================================================
   MANAGED PRODUCT BUY NOW — force quantity: 1 on managed products
   So multi-click Buy Now creates separate lines instead of qty: 3+
   ============================================================ */

(function () {
  'use strict';

  // List of product handles that are "managed" (require cart-page custom fields).
  // Mirror this list in your Liquid templates and JS — single source of truth would be cleaner.
  const MANAGED_HANDLES_EXACT = [
    'temp-tag',
    'custom-tag',
    'custom-tag-add-on-motorcycle-sxs',
    'custom-background-tag-add-on-vehicles',
    'llc-transfer-of-ownership',
    'agency-transfers',
    'llc-restoration-fee',
    'duplicate-title',
  ];
  // Patterns (contains)
  const MANAGED_HANDLE_PATTERNS = [
    'llc-renewal',
    'custom-background',
  ];

  // Detection by product tags from the page meta
  function isManagedProductOnPage() {
    // Check URL
    const path = window.location.pathname.toLowerCase();
    for (const handle of MANAGED_HANDLES_EXACT) {
      if (path === '/products/' + handle) return true;
    }
    for (const pattern of MANAGED_HANDLE_PATTERNS) {
      if (path.includes('/products/') && path.includes(pattern)) return true;
    }
    // Check if Liquid emitted a global product object with tags we care about
    if (window.MTProductTags) {
      if (window.MTProductTags.includes('Package') 
          || window.MTProductTags.includes('Additional') 
          || window.MTProductTags.includes('Transfer')) {
        return true;
      }
    }
    return false;
  }

  function applyQuantityLockdown() {
    if (!isManagedProductOnPage()) return;

    // Force any quantity input on the product page to value 1, max 1, hide if visible
    const qtyInputs = document.querySelectorAll(
      'input[name="quantity"], quantity-input input[type="number"]'
    );
    qtyInputs.forEach((input) => {
      input.value = '1';
      input.setAttribute('max', '1');
      input.setAttribute('min', '1');
      input.setAttribute('readonly', 'readonly');
      // Hide the surrounding quantity widget
      const wrapper = input.closest('quantity-input, .quantity-input, .quantity');
      if (wrapper) wrapper.style.display = 'none';
    });

    // Belt: intercept ANY add-to-cart form submission on this page,
    // override the quantity field to "1" before submission
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', function (e) {
        const qty = form.querySelector('input[name="quantity"]');
        if (qty) qty.value = '1';
      }, true);
    });

    // Suspenders: if the theme uses AJAX add-to-cart via fetch, hook that too.
    // Most modern Shopify themes use product-form.js with a custom element.
    // Force quantity in any FormData / JSON body bound for /cart/add(.js).
    const _fetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        const url = (typeof input === 'string') ? input : (input && input.url) || '';
        if (url.includes('/cart/add')) {
          // Generate a unique stamp so each add creates a new line, never merges
          const uniqueStamp = Date.now().toString() + '-' + Math.random().toString(36).slice(2, 8);
          
          if (init && init.body) {
            // FormData
            if (init.body instanceof FormData) {
              if (init.body.has('quantity')) {
                init.body.set('quantity', '1');
              }
              // Inject unique property to force separate line item
              init.body.set('properties[_Cart Position]', uniqueStamp);
            }
            // JSON string body
            else if (typeof init.body === 'string') {
              try {
                const parsed = JSON.parse(init.body);
                if (parsed && (parsed.quantity !== undefined || parsed.items)) {
                  if (parsed.quantity !== undefined) parsed.quantity = 1;
                  if (Array.isArray(parsed.items)) {
                    parsed.items = parsed.items.map(item => ({
                      ...item,
                      quantity: 1,
                      properties: { ...(item.properties || {}), '_Cart Position': uniqueStamp + '-' + Math.random().toString(36).slice(2, 6) }
                    }));
                  } else {
                    parsed.properties = parsed.properties || {};
                    parsed.properties['_Cart Position'] = uniqueStamp;
                  }
                  init.body = JSON.stringify(parsed);
                }
              } catch (_) { /* not JSON, ignore */ }
            }
          }
        }
      } catch (_) { /* defensive — never break fetch */ }
      return _fetch.apply(this, arguments);
    };

    console.log('[managed-product-buy-now] quantity locked to 1 on this page');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyQuantityLockdown);
  } else {
    applyQuantityLockdown();
  }
})();